import * as React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { toKebabCase } from 'util/StringUtil';
import { slugify } from '~/styles/global';

export interface FancyRadioButtonOption {
	name: string;
	label: string;
	disabled: boolean;
}

export interface FancyRadioButtonsProps {
	name: string;
	options: FancyRadioButtonOption[];
	value: string;
	onChange: (selectedOption: string) => void;
}

/**
 * Renders "fancy" Radio Buttons with controlled state
 *
 * @class SimpleRadioButtons
 * @extends {React.Component<FancyRadioButtonsProps>}
 */
class SimpleRadioButtons extends React.Component<FancyRadioButtonsProps> {
	public render() {
		const { name, options, onChange, value } = this.props;

		return (
			<FormGroup tag="fieldset">
				<div>
					{options.map((option, index) => {
						const radioId = `${slugify(option.name)}-${index}`;

						return (
							<>
								{option.disabled ? (
									<div className="simple-radio__row">
										<input
											disabled
											className="simple-radio__radio-input"
											type="radio"
											name={name}
											id={radioId}
											onChange={() => {
												onChange(option.name);
											}}
											data-testid={`fancy-radio-btn-${toKebabCase(option.label)}`}
										/>
										<Label for={radioId} key={index} check className="fancy-radio__label">
											{option.label} (disabled)
										</Label>
									</div>
								) : (
									<div className="simple-radio__row">
										<input
											className="simple-radio__radio-input"
											type="radio"
											name={name}
											id={radioId}
											onChange={() => {
												onChange(option.name);
											}}
											checked={option.name === value}
											data-testid={`fancy-radio-btn-${toKebabCase(option.label)}`}
										/>
										<Label for={radioId} key={index} check className="simple-radio__label">
											{option.label}
										</Label>
									</div>
								)}
							</>
						);
					})}
				</div>
			</FormGroup>
		);
	}
}

export default SimpleRadioButtons;
